import { Button } from "@aws-amplify/ui-react";
import { CModal, CModalBody, CModalFooter } from "@coreui/react";
import LocalizedStrings from "react-localization";

const ConfirmModal = ({ visible, body, onCancel, onConfirm }) => {
  return (
    <CModal
      alignment="center"
      visible={visible}
      onClose={onCancel}
      backdrop="static"
      portal={false}
    >
      <CModalBody>
        <b>{body}</b>
      </CModalBody>
      <CModalFooter>
        <Button size="small" onClick={onCancel}>
          {strings.modal.cancelButton}
        </Button>
        <Button size="small" variation="primary" onClick={onConfirm}>
          {strings.modal.confirmButton}
        </Button>
      </CModalFooter>
    </CModal>
  );
};

const strings = new LocalizedStrings({
  es: {
    modal: {
      cancelButton: "Cancelar",
      confirmButton: "Confirmar",
    },
  },
});

export default ConfirmModal;
